import styled from '@emotion/styled';

const StyledCancelButton = styled.button`
  display: flex;
  padding: 12px 16px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  flex: 1 0 0;
  border-radius: 6px;
  border: 1px solid var(--dk-line, #e7e9ec);
  background: var(--dk-bg, white);
  color: var(--dk-text, black);
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
`;

const StyledSubmitButton = styled.button`
  display: flex;
  padding: 12px 16px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  flex: 1 0 0;
  border-radius: 6px;
  background: black;
  color: white;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  &:disabled {
    background-color: var(--dk-bg-strong, #e7e9ec);
    color: white;
  }
`;

export { StyledCancelButton, StyledSubmitButton };
